export default __webpack_public_path__ + "static/nashville-hero-70e4035a1d985b2a7a9a49484e1720dd.jpg";